import { Einheit } from 'app/models/core/einheit.model';
import { AgtGpPosModel, GPBases } from 'app/models/gp/agt.gp.pos.model';
import { allExceptBasis, allExceptPro3andSV, allExceptSV, onlyPro3, PosTodo } from '../gp';
const agtPosDef: AgtGpPosModel[] = [];

/////////////////////// 2026 ////////////////////////////////////

/// sonderlocke produktivität

// siehe auch loadProduktivitaet
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: GPBases.map((x) => parseInt(x + '040')),
		planKey: 'produktivitaet',
		einheit: Einheit.bew,
		group: 'eh',
		posText: 'Produktivität',
		hideFromTreeMenu: true,
	}),
);

// kunde
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1],
		planKey: 'idd',
		group: 'kunde',
		posText: 'Weiterbildung IDD Minuten',
		einheit: Einheit.stck,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [5],
		planKey: 'npswert',
		group: 'kunde',
		posText: 'NPS Wert',
		einheit: Einheit.stck,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [6],
		planKey: 'gesamtzufriedenheit',
		group: 'kunde',
		posText: 'Gesamtzufriedenheit 5 Sterne',
		einheit: Einheit.stck,
		decimals: 1,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [8],
		planKey: 'kundenzuwachs',
		group: 'kunde',
		posText: 'Kundenzuwachs Privat S/L/K Anzahl',
		einheit: Einheit.stck,
	}),
);

// vertriebsschwerpunkte
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [11],
		planKey: 'khpwkunfalllfnstmaz',
		group: 'vss',
		posText: 'Kraft Haft PkW und Unfall langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [12],
		planKey: 'unfallkuslfnstmaz',
		group: 'vss',
		posText: 'Unfall KUS langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [13],
		planKey: 'unfallrisikolfnstmaz',
		group: 'vss',
		posText: 'Unfall Risiko langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [14],
		planKey: 'khpwklfnstmaz',
		group: 'vss',
		posText: 'Kraft Haft PKW langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [17],
		planKey: 'unternehmensschutzlfnst',
		group: 'vss',
		posText: 'Unternehmensschutz langfr. Neustück',
		einheit: Einheit.lfNST,
		boniStufen: 2,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [21],
		planKey: 'lebnstmaz',
		group: 'vss',
		posText: 'Leben langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
		boniStufen: 2,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [23],
		planKey: 'kinderpolicenlfnstmaz',
		group: 'vss',
		posText: 'Kinderpolicen langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [24],
		planKey: 'lebenakspvlfnstmaz',
		group: 'vss',
		posText: 'Leben AKS + PV langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [30],
		planKey: 'krankenpflege',
		group: 'vss',
		posText: 'Kranken Pflege langfr. Neustück (MAZ)',
		einheit: Einheit.lfNST,
		boniStufen: 2,
	}),
);

// eingangshürde
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		group: 'eh',
		posId: GPBases.map((x) => parseInt(x + '040')),
		planKey: 'gesamtbewertung',
		posText: 'Gesamtbewertung',
		einheit: Einheit.bew,
		visibleForGps: allExceptPro3andSV,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		group: 'eh',
		posId: [45],
		planKey: 'sachlfnst',
		posText: 'Sach langfr. Neustück',
		einheit: Einheit.stck,
		visibleForGps: allExceptPro3andSV,
	}),
);

// Versicherung und Vorsorge
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [121],
		planKey: 'psachokrunfbew',
		group: 'vuv',
		posText: 'Sach Privat o. Kraft/Unfall Bewertung oAnp (Digi)',
		einheit: Einheit.bew,
		pro3GpPos: { posId: 121, group: 'vuv', posText: 'Sach Privat o. Kraft/Unfall Bewertung oAnp (Digi)' },
		visibleForGps: allExceptSV,
		boniStufen: 3,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [129],
		planKey: 'psachokrunfstk',
		einheit: Einheit.stck,
		group: 'vuv',
		posText: 'Sach Privat o. Kraft/Unfall BZUW-Stück',
		visibleForGps: allExceptSV,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [131, 1190251],
		planKey: 'unfallbew',
		einheit: Einheit.bew,
		group: 'vuv',
		posText: 'Unfall Bewertung oAnp (Digi)',
		boniStufen: 3,
	}),
);

let tempPosId = PosTodo();
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [132, 1190251],
		planKey: 'unfallrisbew',
		group: 'vuv',
		einheit: Einheit.bew,
		posText: 'Unfall Risiko Bewertung oAnp (Digi)',
		problem: 'nicht in der Datenlieferung enthalten',
	}),
);

tempPosId = PosTodo();
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [tempPosId],
		planKey: 'unfallkusbew',
		group: 'vuv',
		einheit: Einheit.bew,
		posText: 'Unfall KUS Bewertung oAnp (Digi)',
		problem: 'nicht in der Datenlieferung enthalten',
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [139],
		planKey: 'unfallrisbestzuwst',
		einheit: Einheit.stck,
		group: 'vuv',
		posText: 'Unfall Risiko BZUW-Stück',
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [151],
		planKey: 'fsachokraftoanpbew',
		group: 'vuv',
		posText: 'Sach Firmen o. Kraft Bewertung oAnp',
		einheit: Einheit.bew,
		visibleForGps: allExceptSV,
		boniStufen: 3,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [161],
		planKey: 'vaglebenbewdigi',
		pro3GpPos: { posId: 151 },
		group: 'vuv',
		posText: 'Leben Bewertung oZE (Digi)',
		einheit: Einheit.bew,
		visibleForGps: allExceptSV,
		boniStufen: 2,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [211],
		planKey: 'krankenzusatzbewdigi',
		group: 'vuv',
		posText: 'Kranken Zusatz Bewertung oDyn (Digi)',
		einheit: Einheit.bew,
		visibleForGps: allExceptSV,
		boniStufen: 3,
	}),
);

// GP PLUS
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180130, 1190130],
		planKey: 'lebenknpebdigi',
		group: 'gpplus',
		posText: 'Leben Einmalbeitrag Bewertung oZE (Digi)',
		einheit: Einheit.bew,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180151, 1190151],
		planKey: 'wiederanlagesumme',
		group: 'gpplus',
		posText: 'Wiederanlagesumme',
		einheit: Einheit.bew,
		boniStufen: 2,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180220, 1190220],
		planKey: 'krankenbkvbew',
		einheit: Einheit.bew,
		group: 'gpplus',
		posText: 'Kranken bKV Bewertung',
		boniStufen: 2,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180240, 1190240],
		planKey: 'krankenofmneuetarifstueck',
		einheit: Einheit.bew,
		group: 'gpplus',
		posText: 'Kranken OFM neue Tarifstück (Digi)',
		boniStufen: 2,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180300, 1190300],
		planKey: 'weiterbildungfonds',
		einheit: Einheit.std,
		group: 'gpplus',
		posText: 'Weiterbildung Kapitalmarktwissen Minuten',
		visibleForGps: allExceptBasis,
	}),
);
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180301, 1190301],
		planKey: 'fondsbew',
		einheit: Einheit.bew,
		group: 'gpplus',
		posText: 'Fonds Bewertung',
		visibleForGps: allExceptBasis,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180311, 1190311],
		planKey: 'fondsnettomittelzufluss',
		einheit: Einheit.bew,
		group: 'gpplus',
		posText: 'Fonds Nettomittelzufluss',
		visibleForGps: allExceptBasis,
		boniStufen: 3,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180401, 1190401],
		planKey: 'baufinanzierungbew',
		group: 'gpplus',
		posText: 'Baufinanzierung Allianz Leben Bewertung',
		einheit: Einheit.bew,
		boniStufen: 3,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180404, 1190404],
		planKey: 'risikiolvbaufi',
		einheit: Einheit.stck,
		group: 'gpplus',
		posText: 'Leben Risiko i.V.m. Baufi AZL Neustück',
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180421, 1190421],
		planKey: 'baufinanzierungwuro',
		einheit: Einheit.bew,
		group: 'gpplus',
		posText: 'Baufinanzierung Wüstenrot Bewertung',
		boniStufen: 2,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180450, 1190450],
		planKey: 'bausparenneustueck',
		einheit: Einheit.stck,
		group: 'gpplus',
		posText: 'Bausparen Neustück',
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180451, 1190451],
		planKey: 'bausparenbewertung',
		einheit: Einheit.bew,
		group: 'gpplus',
		posText: 'Bausparen Bewertung',
		boniStufen: 3,
	}),
);

// Incentives für Fachagenturen
agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180500],
		planKey: 'tvtrvhgruppenunfall',
		einheit: Einheit.stck,
		group: 'incfuerfach',
		posText: 'TV, TR, VH, GruppenUnfall langfr. Neustück',
		boniStufen: 3,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180700, 1190700],
		planKey: 'lfirmenknp80ris',
		einheit: Einheit.stck,
		group: 'incfuerfach',
		posText: 'VAG: L-Firmen KNP80 + Ris',
		visibleForGps: onlyPro3,
	}),
);

agtPosDef.push(
	new AgtGpPosModel({
		year: 2026,
		posId: [1180710, 1190710],
		planKey: 'krankenbkVbew',
		einheit: Einheit.stck,
		group: 'incfuerfach',
		posText: 'VAG:L-F KNP80+R F-Online',
		visibleForGps: onlyPro3,
	}),
);

// Info: ohne digitale Daten / ohne MAZ
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'khpwkunfalllfnstomaz',
// 		group: 'ohnedigi',
// 		posText: 'Kraft Haft PkW und Unfall langfr. Neustück (oMAZ)',
// 		einheit: Einheit.lfNST,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'lebenlfnstomaz',
// 		group: 'ohnedigi',
// 		posText: 'Leben langfr. Neustück (oMAZ)',
// 		einheit: Einheit.lfNST,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'lebenbewodigi',
// 		group: 'ohnedigi',
// 		posText: 'Leben Bewertung oZE (oDigi)',
// 		einheit: Einheit.bew,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'krankenpflegeomaz',
// 		group: 'ohnedigi',
// 		posText: 'Kranken Pflege langfr. Neustück (oMAZ)',
// 		einheit: Einheit.lfNST,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'psachbewodigi',
// 		group: 'ohnedigi',
// 		posText: 'Sach Privat o. Kraft/Unfall Bewertung (oDigi)',
// 		einheit: Einheit.bew,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'unfallbewodigi',
// 		group: 'ohnedigi',
// 		posText: 'Unfall Bewertung (oDigi)',
// 		einheit: Einheit.bew,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'krankenzusatzbewodigi',
// 		group: 'ohnedigi',
// 		posText: 'Kranken Zusatz Bewertung oDyn (oDigi)',
// 		einheit: Einheit.bew,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );
// agtPosDef.push(
// 	new AgtGpPosModel({
// 		year: 2026,
// 		posId: [PosTodo()],
// 		planKey: 'krankenofmnstodigi',
// 		group: 'ohnedigi',
// 		posText: 'Kranken OFM Neustück (oDigi)',
// 		einheit: Einheit.stck,
// 		problem: 'pos_id noch zu ermitteln',
// 	}),
// );

export const AgtPositionen2026 = agtPosDef;
